import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { http } from './helpers/http';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { registerMaintenanceModeInterceptor } from '@urbanx/agx.auth.client';

registerMaintenanceModeInterceptor(axios, import.meta.env.BASE_URL);

sessionStorage.setItem(http.sessionName, uuidv4());

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
